import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
import { trackBookingCtaClick } from '../../utils/metaPixel';
export function Authority() {
  const {
    t
  } = useLanguage();
  const stats = t('authority.stats');
  const pillars = t('authority.pillars');
  const easeOutCubic = [0.33, 1, 0.68, 1];
  const scrollToContact = () => {
    trackBookingCtaClick('authority');
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 lg:py-28 bg-brand-dark text-brand-cream relative overflow-hidden" data-id="element-27" data-mp="emdbjd1goc2q">
      {/* Subtle grain */}
      <div className="absolute inset-0 bg-grain opacity-50 pointer-events-none" data-id="element-28" data-mp="npeghaelbx4t"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-29" data-mp="3w4y51w4bgrdj">
        <div className="text-center max-w-2xl mx-auto mb-14" data-id="element-30" data-mp="3w3emtzz3o694">
          <span className="text-brand-gold/80 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-31" data-mp="3s3w4nbyny99z">
            {t('authority.eyebrow')}
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light mb-6 tracking-tight" data-id="element-32" data-mp="4uisxdknb87j">
            {t('authority.heading')}
          </h2>
          <div className="w-12 h-px bg-brand-gold mx-auto mt-10" data-id="element-33" data-mp="eng7x9qfif1e"></div>
        </div>

        {/* Stats row */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.9,
        ease: easeOutCubic
      }} className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12 max-w-5xl mx-auto mb-16 pb-14 border-b border-brand-cream/10" data-id="element-34" data-mp="jk6nlvybn8ma">
          {stats.map((stat: any, idx: number) => <div key={idx} className="text-center" data-id="element-35" data-mp="1c9x1c3w1k8hv" data-mpi={idx}>
              <p className="font-serif text-5xl lg:text-6xl text-brand-cream font-light mb-3" data-id="element-36" data-mp="1c8lyq7ec16sc">
                {stat.value}
              </p>
              <p className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50" data-id="element-37" data-mp="33eh32e1iznhp">
                {stat.label}
              </p>
            </div>)}
        </motion.div>

        {/* Pillars grid */}
        <div className="grid md:grid-cols-2 gap-10 lg:gap-14 max-w-5xl mx-auto mb-16" data-id="element-38" data-mp="3dc4yz7avb11g">
          {pillars.map((pillar: any, idx: number) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: idx * 0.15,
          ease: easeOutCubic
        }} className="flex gap-6" data-id="element-39" data-mp="2pkpsd2c25xke" data-mpi={idx}>
              <span className="font-serif text-2xl text-brand-gold/80 font-light italic shrink-0" data-id="element-40" data-mp="1rsrf9xwjoq68">
                0{idx + 1}
              </span>
              <div data-id="element-41" data-mp="1wlc74tvw4t74">
                <h3 className="font-serif text-2xl text-brand-cream font-light mb-3" data-id="element-42" data-mp="1wlueomo06tuc">
                  {pillar.title}
                </h3>
                <p className="text-brand-cream/60 font-light leading-relaxed" data-id="element-43" data-mp="1mtex3qgmc79z">
                  {pillar.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Financing row */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.9,
        ease: easeOutCubic
      }} className="text-center max-w-3xl mx-auto pt-14 border-t border-brand-cream/10" data-id="element-44" data-mp="2fidh6t4axjhx">
          <p className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/40 mb-6" data-id="element-45" data-mp="1ad6zd37ugc0z">
            {t('authority.financingTitle')}
          </p>
          <p className="font-serif text-xl lg:text-2xl text-brand-cream/80 font-light leading-relaxed mb-12 max-w-xl mx-auto" data-id="element-46" data-mp="15jvvnaybwbda">
            {t('authority.financingNote')}
          </p>

          <div className="mt-16" data-id="element-47" data-mp="vplyzh2csqwr">
            <Button variant="luxury" size="lg" onClick={scrollToContact} className="border-brand-cream/30 text-brand-cream hover:bg-brand-cream hover:text-brand-dark" data-id="element-48" data-mp="1tb9l9953hsuk">
              {t('nav.cta')}
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}